module.exports = {
      id: "solid-arrow-down-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite.svg#solid-arrow-down",
      toString: function () {
        return this.url;
      }
    }